// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"cd6fda52","43":"3727b762","50":"e13df501","98":"2891e450","376":"4ab18ad5","864":"703bdc10","892":"72b8f9bc","934":"6ce243a7","950":"1b04c948"}[chunkId] + ".chunk.js";
};